import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'logisticCompany',
  pure: true,
  standalone: false,
})
export class LogisticCompanyPipe implements PipeTransform {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(private readonly translateService: TranslateService) {}
  transform(value: string): Observable<string> {
    return this.translateService
      .get('orders.logisticProvider')
      .pipe(map((i18n: Record<string, string>) => i18n[value] ?? value));
  }
}
